import { c as g, j as r } from "./createRuntimeFn-62c9670f.esm-CXdMsbWY.js";
import { forwardRef as o } from "react";
import { b as j } from "./import-_PjWeMm4.js";
import { B as n } from "./Typography-2ZjCxfuP.js";
/* empty css                              */
var b = g({ defaultClassName: "_1kgv65v2", variantClassNames: { theme: { dark: "_1kgv65v3", light: "_1kgv65v4" }, variant: { primary: "_1kgv65v5", secondary: "_1kgv65v6", tertiary: "_1kgv65v7" }, size: { small: "_1kgv65v8", medium: "_1kgv65v9", large: "_1kgv65va" }, iconLayout: { sx: "_1kgv65vb", dx: "_1kgv65vc" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "_1kgv65vd"], [{ theme: "light", variant: "primary" }, "_1kgv65ve"], [{ theme: "dark", variant: "secondary" }, "_1kgv65vf"], [{ theme: "light", variant: "secondary" }, "_1kgv65vg"], [{ theme: "dark", variant: "tertiary" }, "_1kgv65vh"], [{ theme: "light", variant: "tertiary" }, "_1kgv65vi"]] }), u = g({ defaultClassName: "gbijxg1", variantClassNames: { size: { small: "gbijxg2", medium: "gbijxg3", large: "gbijxg4" } }, defaultVariants: {}, compoundVariants: [] }), k = g({ defaultClassName: "gbijxg5", variantClassNames: { theme: { dark: "gbijxg6", light: "gbijxg7" }, variant: { primary: "gbijxg8", secondary: "gbijxg9", tertiary: "gbijxga" }, size: { small: "gbijxgb", medium: "gbijxgc", large: "gbijxgd" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "gbijxge"], [{ theme: "dark", variant: "secondary" }, "gbijxgf"], [{ theme: "light", variant: "primary" }, "gbijxgg"], [{ theme: "light", variant: "secondary" }, "gbijxgh"]] }), c = g({ defaultClassName: "gbijxgi", variantClassNames: { variant: { primary: "gbijxgj", secondary: "gbijxgk", tertiary: "gbijxgl" }, theme: { dark: "gbijxgm", light: "gbijxgn" }, size: { small: "gbijxgo", medium: "gbijxgp", large: "gbijxgq" } }, defaultVariants: {}, compoundVariants: [[{ theme: "dark", variant: "primary" }, "gbijxgr"], [{ theme: "dark", variant: "secondary" }, "gbijxgs"], [{ theme: "light", variant: "primary" }, "gbijxgt"], [{ theme: "light", variant: "secondary" }, "gbijxgu"]] });
const h = ({ size: i, theme: t, variant: a }) => /* @__PURE__ */ r.jsxs("div", { className: u({ size: i }), children: [
  /* @__PURE__ */ r.jsx("div", { className: k({ size: i, theme: t, variant: a }) }),
  /* @__PURE__ */ r.jsx("div", { className: c({ size: i, theme: t, variant: a }) })
] }), y = o(({
  children: i,
  disabled: t = !1,
  loading: a = !1,
  variant: v = "primary",
  theme: s = "dark",
  icon: m,
  iconLayout: l = "sx",
  size: e = "medium",
  ...d
}, x) => /* @__PURE__ */ r.jsxs(
  j,
  {
    ...d,
    ref: x,
    isDisabled: t,
    className: b({ iconLayout: l, size: e, theme: s, variant: v }),
    children: [
      a && /* @__PURE__ */ r.jsx(h, { size: e, theme: s }),
      !a && m ? m : null,
      !a && (e === "small" || e === "medium") ? /* @__PURE__ */ r.jsx(n, { size: "m", strong: !0, noMargin: !0, children: i }) : null,
      !a && e === "large" ? /* @__PURE__ */ r.jsx(n, { size: "l", strong: !0, noMargin: !0, children: i }) : null
    ]
  }
));
y.displayName = "Button";
export {
  y as B
};
//# sourceMappingURL=Button-BNj0TeuP.js.map
